import { createApolloClient } from './config';
import React, { Component } from 'react';
import { ApolloClient, ApolloProvider } from '@apollo/client';
// import { ErrorResponse } from 'apollo-link-error';
import { ErrorResponse } from '@apollo/client/link/error';

interface PropsApollo {
  uri: string;
  uriWs: string;
  firebaseAppAuth: any;
  children: React.ReactNode;
  errorCallback: (error: ErrorResponse) => void;
}

/**
 * One client per Firebase auth instance, i.e. one per page.
 *
 * Every client opens its own WebSocket and nothing closes it, so the client
 * must outlive any re-render or remount of the provider. Keeping it on the
 * component instance is not enough: an ErrorBoundary above the provider
 * remounts the whole subtree after a render error, and each remount used to
 * leave one more socket open (learners on ss held 110-156 at once).
 */
const clients = new WeakMap<object, ApolloClient<any>>();

const getClient = ({
  uri,
  uriWs,
  firebaseAppAuth,
  errorCallback,
}: PropsApollo) => {
  const key = firebaseAppAuth ?? clients;
  let client = clients.get(key);
  if (!client) {
    client = createApolloClient(uri, uriWs, firebaseAppAuth, errorCallback);
    clients.set(key, client);
  }
  return client;
};

export class ApolloCoreProvider extends Component<PropsApollo> {
  render() {
    return (
      <ApolloProvider client={getClient(this.props)}>
        {this.props.children}
      </ApolloProvider>
    );
  }
}
